import { useLocation } from 'react-router-dom'
import { PAGE_SECTIONS } from '../lib/constants'
import type { PageContext } from '../lib/types'

export const getPageSection = (pathname: string): string | undefined => {
  const match = Object.keys(PAGE_SECTIONS)
    .filter(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
    .sort((a, b) => b.length - a.length)[0]
  return match ? PAGE_SECTIONS[match] : undefined
}

export const usePageContext = (): PageContext => {
  const { pathname } = useLocation()
  return { path: pathname, section: getPageSection(pathname) }
}
